import { render, staticRenderFns } from "./AdminUsersDetail.vue?vue&type=template&id=36413287&scoped=true"
import script from "./AdminUsersDetail.vue?vue&type=script&lang=js"
export * from "./AdminUsersDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersDetail.vue?vue&type=style&index=0&id=36413287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36413287",
  null
  
)

export default component.exports